import { ModelsHistoryView } from "../_components";

export default function ContentModelsHistoryPage() {
  return <ModelsHistoryView />;
}
